var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section){return _c('SettingsItem',{key:section.title,attrs:{"title":section.title,"text":section.text,"disabled":section.disabled,"disabledText":section.disabledText,"ctaText":section.ctaText,"dataCy":section.dataCy},on:{"click":section.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }